import React from 'react';
import parse from 'html-react-parser';

export default function ClientCard({ 
    candidate, 
    candidates,
    used, 
    availableVotes, 
    askForVote, 
    seeMore, 
    askForKnow, 
    askForPresent 
}) {

  const trucateText = (text) => {
    let text2 = text;
    const myArray = text.split(".");
    if (myArray.length > 1) return parse(myArray[0] + '.');
    else return parse(text2);
  };

  if (candidate.clase === 0) {
    return (
      <div className="box" key={candidate.IDCandidato}>
        <div>
          <div className="image">
            <img src={candidate.Foto} className="candidato" alt={candidate.Nombre} />
          </div>
          <div className="name">{candidate.Nombre}</div>
          <div>{trucateText(candidate.Descripcion)}</div>
          <div className="btns">
            <button 
              disabled={candidate.estado === "Allow" && availableVotes > 0 ? "" : "disabled"} 
              className={candidate.estado === "Allow" && availableVotes > 0 ? "button-candidate" : "button-candidate-disabled"} 
              onClick={e => askForVote(
                candidate.IDCandidato, 
                candidate.Nombre, 
                e, 
                "Sí desea emitir su voto a favor del Sr. " + candidate.Nombre + " presione el botón <b>SI</b>. Para regresar a la opción anterior sin emitir voto, presione <b>REGRESAR</b>.", 
                "Si"
              )} 
              id={candidate.IDCandidato}
            >
              Votar
            </button>
            <button 
              className="button-candidate"  
              onClick={() => seeMore(candidate)} 
              id={"ver" + candidate.IDCandidato}
            >
              Ver Más
            </button>
          </div>
        </div>
      </div>
    );
  } else if (candidate.clase === 1) {
    return (
      <div className="box2" key={candidate.IDCandidato}>
        <div>
          <div className="name">{candidate.campana}</div>
          <div className="exception-div">{parse(candidate.Descripcion)}</div>
          <center>
            <button 
              disabled={candidate.estado === "Allow" && availableVotes > 0 ? "" : "disabled"} 
              className={candidate.estado === "Allow" && availableVotes > 0 ? "button-candidate" : "button-candidate-disabled"} 
              onClick={e => askForKnow(candidate.IDCandidato, candidate.Nombre, e)} 
              id={candidate.IDCandidato}
            >
              Si
            </button>
          </center>
        </div>
      </div>
    );
  } else if (candidate.clase === 3) {
    return (
      <div className="box2" key={candidate.IDCandidato}>
        <div>
          <div className="name">{candidate.campana}</div>
          <div className="exception-div">{parse(candidate.Descripcion)}</div>
          <center>
            <button 
              disabled={candidate.estado === "Allow" ? "" : "disabled"} 
              className={candidate.estado === "Allow" ? "button-candidate" : "button-candidate-disabled"} 
              onClick={e => askForPresent(candidate.IDCandidato, candidate.Nombre, e)} 
              id={candidate.IDCandidato}
            >
              {candidate.Nombre}
            </button>
          </center>
        </div>
      </div>
    );
  } else if (candidate.clase === 5 || candidate.clase === -1) {
    const candidate1 = candidates[0];
    const candidate2 = candidates[1];
    if (!candidate1 || !candidate2) return <div></div>;

    return (
      <div className="box2" key={candidate.IDCandidato}>
        <div>
          <div className="name">{candidate.campana}</div>
          <div className="exception-div">{trucateText(candidate.Descripcion)}</div>
          <center>
            <button 
              disabled={candidate1.estado === "Allow" ? (used === false ? "" : "disabled") : "disabled"} 
              className={(candidate1.Nombre === "No" ? "no-botton button-candidate " : "") +
                         (candidate1.estado === "Allow" ? (used === false ? "button-candidate" : "button-candidate-disabled") : "button-candidate-disabled")} 
              onClick={e => askForVote(candidate1.IDCandidato, candidate1.Nombre, e)} 
              id={candidate1.IDCandidato}
            >
              {candidate1.Nombre}
            </button>
            <button 
              disabled={candidate1.estado === "Allow" ? (used === false ? "" : "disabled") : "disabled"} 
              className={candidate1.estado === "Allow" ? (used === false ? "button-candidate" : "button-candidate-disabled") : "button-candidate-disabled"} 
              onClick={e => askForVote(candidate2.IDCandidato, candidate2.Nombre, e)} 
              id={candidate2.IDCandidato}
            >
              {candidate2.Nombre}
            </button>
          </center>
        </div>
      </div>
    );
  }

  return <div></div>;
}
